export default __webpack_public_path__ + "static/media/7_proximidade.2291eead.svg";